import ReactApexChart from "react-apexcharts";

export const AdSpending = ({ stats }) => {
  const rows = Array.isArray(stats) ? stats : []
  if (rows.length === 0) {
    return (
      <div className="rounded-lg bg-gray-100 border border-gray-200 p-8 text-center text-gray-600 text-sm">
        No spending breakdown data for the selected filters.
      </div>
    )
  }

  return (
    <ReactApexChart
    height={400}
      series={[
        {
          name: "Total Ads",
          data: rows.map((item: { total_ads: number }) => item.total_ads),
        },
        {
          name: "Total Spent",
          data: rows.map((item: { total_spent: number }) => item.total_spent),
        },
      ]}
      options={{
        title: {
          text: "Total Ads Spending",
          align: "left",
        },
        chart: {
          height: 250,
          type: "area",
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          curve: "smooth",
        },
        xaxis: {
            labels: {
                formatter: function (value) {
                  return `Ad Package: ${value}`;
                }
              },
          categories: rows.map((item: { ad_amount?: string; _id?: string }) => item.ad_amount ?? item._id ?? ""),
        },
      }}
    />
  );
};
